import { createRequestTypes } from '../utils';

export const PRODUCT_ACTION_LIST = createRequestTypes('productAction/PRODUCT_ACTION_LIST');
export const SAVE_PRODUCT_ACTION = createRequestTypes('productAction/SAVE_PRODUCT_ACTION');
export const SHOW_PRODUCT_ACTIONS_HISTORY = 'productAction/SHOW_PRODUCT_ACTIONS_HISTORY';
